let apiUrl: string;

const getAPIFullUrl = (): string => {
    let urlOrigin: string;
    if (process.env.REACT_APP_API_URL) {
        urlOrigin = process.env.REACT_APP_API_URL;
    } else {
        urlOrigin = 'https://' + replaceAppWithApi(new URL(window.location.href).host);
    }

    return urlOrigin + '/api/v1';
};

function replaceAppWithApi(str: string): string {
    return str.replace(/app/g, "api");
}

apiUrl = getAPIFullUrl();

export const getAPIUrl = (): string => {
    return apiUrl;
};
